import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=5a1144a0&scoped=true"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"
import style0 from "./Reports.vue?vue&type=style&index=0&id=5a1144a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1144a0",
  null
  
)

export default component.exports